// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-search-container {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
    z-index: 1000;
}

.map-search-form {
    display: flex;
    gap: 8px;
}

.map-search-input {
    flex: 1 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.2s ease;
}

.map-search-input:focus {
    outline: none;
    border-color: #007bff;
}

.map-search-btn {
    padding: 8px 16px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.map-search-btn:hover {
    background: #0056b3;
}

.search-results {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    list-style: none;
    padding: 0;
    margin: 4px 0 0 0;
    z-index: 2000;
}

.search-results li {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    font-size: 13px;
    color: #333;
}

.search-results li:hover {
    background-color: #f8f9fa;
}

.search-results li:last-child {
    border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/components/MapSearch.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;IACxC,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".map-search-container {\r\n    position: relative;\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n    z-index: 1000;\r\n}\r\n\r\n.map-search-form {\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n.map-search-input {\r\n    flex: 1;\r\n    padding: 8px 12px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    transition: border-color 0.2s ease;\r\n}\r\n\r\n.map-search-input:focus {\r\n    outline: none;\r\n    border-color: #007bff;\r\n}\r\n\r\n.map-search-btn {\r\n    padding: 8px 16px;\r\n    background: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.map-search-btn:hover {\r\n    background: #0056b3;\r\n}\r\n\r\n.search-results {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    right: 0;\r\n    background: white;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 4px 0 0 0;\r\n    z-index: 2000;\r\n}\r\n\r\n.search-results li {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #f0f0f0;\r\n    font-size: 13px;\r\n    color: #333;\r\n}\r\n\r\n.search-results li:hover {\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.search-results li:last-child {\r\n    border-bottom: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
